import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetServerSidePropsResult,
} from "next";

interface ApiResponse {
  data: Array<{
    attributes?: {
      design?: string;
    };
  }>;
}

interface PageProps {
  apiResData?: ApiResponse;
  isNew?: boolean;
}

export const getServerSideProps: GetServerSideProps<PageProps> = async ({
  res,
}: GetServerSidePropsContext): Promise<GetServerSidePropsResult<PageProps>> => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  // Redirect immediately (this ends function execution)
  return {
    redirect: {
      permanent: true,
      destination: `/blog#category=whitepaper`,
    },
  };
};

const WhitepaperPage = () => {
  return <></>;
};

export default WhitepaperPage;
